import React, { useState } from "react";
import { ReactComponent as WhatsappIcon } from "../../../assets/icons/whatsapp.svg";
import { ReactComponent as WhatsappColorIcon } from "../../../assets/icons/whatsapp-color.svg";
import { ReactComponent as CrossIcon } from "../../../assets/icons/cross.svg";
import AlexaImg from "../../../assets/img/alexa.jpg";
import { welcomeMessage } from "../../../constants/contents";
import { whatsappTramy } from "../../../constants/urls";
import "./styles.css";

function ChatBot() {
  const [boxIsOpen, setBoxIsOpen] = useState(false);

  const handleBox = () => {
    setBoxIsOpen(!boxIsOpen);
  };

  return (
    <div className="chatbot">
      <button className="chatbot__button" onClick={handleBox}>
        Quiero más información <WhatsappIcon />
      </button>

      <div
        className="chatbot__box"
        style={{ display: `${boxIsOpen ? "block" : "none"}` }}
      >
        <div className="box__welcome">
          <button className="close" onClick={handleBox}>
            <CrossIcon />
          </button>
          <WhatsappColorIcon />
          <p>{welcomeMessage}</p>
        </div>

        <a
          className="box__assistant"
          href={whatsappTramy}
          target="_blank"
          rel="noreferrer"
        >
          <img src={AlexaImg} alt="alexa assistent" />
          <div className="box__assistant-info">
            <h2>Customer Success</h2>
            <h1>Alexa</h1>
            <p>
              <span className="dot"></span> Online
            </p>
          </div>
        </a>
      </div>
    </div>
  );
}

export default ChatBot;
